
const parseArrayOfStrings = (str: string): string[] | null => {
    try {
        const parsed: unknown = JSON.parse(str);
        if (Array.isArray(parsed) && parsed.every(item => typeof item === 'string')) {
            return parsed;
        }
    // eslint-disable-next-line no-empty
    } catch {}

    return null;
}

export default parseArrayOfStrings